import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { SUPPORTED_LANGUAGES, LANGUAGE_STORAGE_KEY } from "@/i18n";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "de").slice(0, 2);

  const handleChange = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    } catch (_) {
      // ignore storage errors (private mode etc.)
    }
  };

  return (
    <label
      className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2 h-9 text-xs text-slate-600 hover:border-slate-300 transition-colors"
      data-testid="language-switcher"
      title={t("topbar.language")}
    >
      <Globe className="h-3.5 w-3.5 text-slate-500" aria-hidden="true" />
      <select
        value={SUPPORTED_LANGUAGES.includes(current) ? current : "de"}
        onChange={handleChange}
        className="bg-transparent outline-none text-xs font-medium uppercase tracking-wider cursor-pointer pr-1"
        data-testid="language-switcher-select"
        aria-label={t("topbar.language")}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng} data-testid={`language-option-${lng}`}>
            {lng.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}
